import { MaterialTypeEnum } from "../FlowEditPage/services/template";

const commonList = ["txt", "doc", "docx", "xls", "xlsx", "pdf"];
const imageList = ["jpg", "jpeg", "png", "gif", "bmp"];
const videoList = ["mp4"];
const audioList = ["wav", "mp3"];

export function getMaterialAccessListByType(type: MaterialTypeEnum) {
  if (type === MaterialTypeEnum.Image) {
    return imageList;
  } else if (type === MaterialTypeEnum.Video) {
    return videoList;
  } else if (type === MaterialTypeEnum.Audio) {
    return audioList;
  } else {
    return [...commonList, ...imageList, ...videoList, ...audioList];
  }
}
